<template>
  <div class="col-12 col-lg-6 c g">
    <div class="card">
        <div class="card-body">
            <h5>
                ارسال التأخر والانصراف المبكر التلقائي
            </h5>
            <hr>
          <div class="form-check">
            <label class="form-check-label">
              <input type="checkbox" class="form-check-input" value="1" v-model="send_late">
              <h5>
                ارسال التاخر تلقائياً للمعلم
              </h5>
                </label>
            </div><br>
            <div class="form-group">
                <h5 for="">رسالة التاخر</h5>
                <textarea class="form-control" name="" id="" rows="3" v-model="late_message"></textarea>
            </div>
            <hr>
            <div class="form-check">
                <label class="form-check-label">
                <input type="checkbox" class="form-check-input" value="1" v-model="send_early">
                <h5>
                    ارسال الانصراف المبكر تلقائياً للمعلم
                </h5>
                    </label>
                </div>
                <template v-if="send_early">
                    <br>
                    <div class="form-group">
                        <h5 for="">رسالة الانصراف المبكر</h5>
                        <textarea class="form-control" name="" id="" rows="3" v-model="early_message"></textarea>
                    </div>
                    <div class="form-group">
                        <h5 for="">بداية احتساب الانصراف المبكر</h5>
                        <input type="time" class="form-control" v-model="early_start_time">
                        <small class="text-muted">اذا انصرف المعلم قبل هذا الوقت لن تُرسل له رسالة الانصراف المبكر</small>
                    </div>
                </template>
                <hr>
            <div class="form-group">
              <h5 for="">ارسال الرسائل التلقائية عبر</h5>
              <select class="form-control" v-model="send_teachers_late_method">
                <option value="sms">الرسائل النصية SMS</option>
                <option value="whatsapp">الواتس الذكي</option>
                <option value="xwa">الواتس المباشر (الاداة المتطورة)</option>
              </select>
            </div>
            <div class="col-12 text-center">
                <button class="btn btn-primary" @click="save()">
                    حفظ
                </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            send_late: false,
            late_message: "تنبيه هام \nأخي الموظف ( {name} ) \nبناءً على ما تم تسجيله من قبلكم في نظام حضوري نفيدكم أنه تم تسجيل تأخرك لهذا اليوم \nالساعة : {time} \nنأمل التبكير لتفادي احتساب دقائق التأخر إدارة المدرسة",
            send_teachers_late_method: "sms",
            early_message: "تنبيه هام \nأخي الموظف ( {name} ) \nبناءً على ما تم تسجيله من قبلكم في نظام حضوري نفيدكم أنه تم تسجيل انصرافك لهذا اليوم \nالساعة : {time} \nنأمل الانصراف في الموعد المحدد لتفادي احتساب دقائق التأخر إدارة المدرسة",
            user: JSON.parse(localStorage.getItem('user')),
            send_early: false,
            early_start_time: "10:00"
        }
    },
    created(){
      if(!checkPer("teachers|settings")){
          this.$router.push('/NotPermitted')
          return false;
      }
        var g = this;
        $.post(api + '/user/teachers/settings/send', {
            jwt: g.user.jwt
        }).then(function(r){
            g.send_late = r.response.send_late ?? false;
            g.late_message = r.response.late_message;
            g.send_early = r.response.send_early ?? false;
            g.send_teachers_late_method = r.response.send_teachers_late_method;
            g.early_message = r.response.early_message;
            g.early_start_time = r.response.early_start_time ?? "10:00";
            
        })
    },
    methods: {
        save(){
            var g = this;
            $.post(api + '/user/teachers/settings/send/save', {
                jwt: g.user.jwt,
                late_message: g.late_message,
                send_late: g.send_late,
                early_message: g.early_message,
                send_early: g.send_early,
                early_start_time: g.early_start_time,
                send_teachers_late_method: g.send_teachers_late_method
            }).then(function(r){
                alert("تم الحفظ", 100)
            })
        }
    }
}
</script>

<style>

</style>